import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";

import GalleryServiceScreen from "../GalleryServiceScreen";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import {Tools} from "../../../../../tools/Tools";

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashGetAllData.results.item_count,
    token: state.reducerSplashGetAllData.token,
    results: state.reducerGalleryServiceScreen.results,
    NoInternetDialog: state.reducerGalleryServiceScreen.NoInternetDialog,
    showLoading: state.reducerGalleryServiceScreen.showLoading,
    lazyload_end: state.reducerGalleryServiceScreen.lazyload_end,
    showRefresh: state.reducerGalleryServiceScreen.showRefresh,
    failed: state.reducerGalleryServiceScreen.failed,
    page: state.reducerGalleryServiceScreen.page,
    empty: state.reducerGalleryServiceScreen.empty,
    DataSplashScreen: state.reducerSplashGetAllData,
    resultsSet: state.reducerGalleryServiceScreen.resultsSet,
    isLoadingSet: state.reducerGalleryServiceScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerGalleryServiceScreen.NoInternetDialogSet,
    ListFilter: state.reducerGalleryServiceScreen.ListFilter,
    id: state.reducerGalleryServiceScreen.id,
    // isLoadingSetSubmitRequestScreen: state.reducerSubmitRequestScreen.isLoadingSet,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionListFilter: (data) => dispatch(serviceActionListFilter(data)),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id) => {
    let pagee;
    let url_send = "";

    switch (type) {
        case typeExport.TypeGetGalleryServiceScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            page === 1 ? dispatch(serviceActionRefresh()) : dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetGalleryServiceScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();
    formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('token', store.getState().reducerSplashGetAllData.token == null ? '' : store.getState().reducerSplashGetAllData.token);
    formData.append('page', params.page);
    formData.append('type', params.type);
    formData.append('listFilter', JSON.stringify(params.listFilter));
    formData.append('trackingCode', params.trackingCode);
    Tools.addAllFormData(formData,true,"City");

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };

    axios.post(url, formData, config)
        .then(async response => {

            switch (type) {

                case typeExport.TypeGetGalleryServiceScreen:


                    if (response.data.success) {


                        let dataResponse = response.data;
                        let data = dataResponse.result && dataResponse.result.list ? dataResponse.result.list : dataResponse.result;

                        dispatch(serviceActionListFilter(response.data.result.searchItems));

                        if (data == null) data = []
                        // let arr = store.getState().reducerGalleryServiceScreen.results
                        // if (page == 1) {
                        //     arr = data
                        //     global.list_menu_shahrdar=response.data.result.menu
                        // } else {
                        //     if (arr.length > 0)
                        //     //    arr.push(data);
                        //         arr = [...arr, ...data]
                        //     else
                        //         arr = data
                        // }

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(data, pagee));
                        }

                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(data, pagee)));
                        }


                        // let t=((getState === null || getState === undefined || getState === '') ? id : getState.route.params.data.type);
                        // await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListOperatorApply +  t, arr)
                        // if (page == 1)
                        //     await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListOperatorApplyFilter + t, response.data.result.searchItems)

                    } else {
                        dispatch(serviceActionError(response, page))

                        //alert(response.data.message)
                    }

                    break;

                case typeExport.TypeSetGalleryServiceScreen:
                    if (response.data.status)
                        dispatch(serviceActionSuccessSet(response.data, id))
                    else
                        dispatch(serviceActionError(e, page))
                    //    alert(response.data.message)
                    break;
                default:
                    alert("")
            }
        }).catch((e) => {
        console.log("ahmad=> error")
        switch (type) {
            case typeExport.TypeGetGalleryServiceScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetGalleryServiceScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        } else {
            switch (type) {
                case typeExport.TypeGetGalleryServiceScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetGalleryServiceScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetGalleryServiceScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetGalleryServiceScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetGalleryServiceScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.GalleryServiceScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.GalleryServiceScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.GalleryServiceScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1,

})
export const serviceActionSuccess = (data, page) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page) => ({
    type: typeExport.GalleryServiceScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEmpty = (page) => ({
    type: typeExport.GalleryServiceScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page
})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.GalleryServiceScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.GalleryServiceScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_AddSubList,

    data: data,

})

export const serviceActionListFilter = (data) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_LIST_FILTER,

    ListFilter: data,

})


export const serviceActionSetLike = (data, index,res) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_SET_LIKE,

    index: index,
    data: data,
    res: res,

})
export const serviceActionSetDisplayImage = (data, index, indexSwiper) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_SET_DISPLAY_IMAGE,

    index: index,
    indexSwiper: indexSwiper,

    data: data,

})
export const serviceActionSetDisplayComment = (data, index, indexWork) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_SET_DISPLAY_COMMENT,

    index: index,
    indexWork: indexWork,
    data: data,

})
export const serviceActionSetComment = (data, index, indexWork) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_SET_COMMENT,

    index: index,
    indexWork: indexWork,
    data: data,

})
export const serviceActionAddFile = (data, index) => ({

    type: typeExport.GalleryServiceScreen_SERVICE_ADD_FILE,

    index: index,
    data: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(GalleryServiceScreen);
